/* eslint-disable react/forbid-prop-types */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import { Link } from 'gatsby';
import Link from '@components/i18n/Link';
import {useSelector} from "react-redux";
import {getLanguagePrefix} from "@helpers";

export const AuthLink = ({ menu, item, styles, isAuth, onClick, user }) => {
  const isUser = item.link.options.attributes?.ifUser === 'show' && isAuth;
  const notUser = item.link.options.attributes?.ifUser === 'hide' && !isAuth;
  const isMainNav =
    item.link.options.attributes?.ifMainNav === 'show' &&
    menu === 'MAIN_NAVIGATION';
  const isSidebar =
    item.link.options.attributes?.ifSidebar === 'show' &&
    menu === 'SIDE_NAVIGATION';
  const shouldDisplay = (isUser || notUser) && (isMainNav || isSidebar);

  const { vehicles } = user || {};

  const noReservations = vehicles && vehicles.length < 1;
  const singleReservation = vehicles && vehicles.length === 1;
  const multiReservation = vehicles && vehicles.length > 1;

  const noResLink = item.link.uri.replace('reservations', 'designs');
  const restResLink = item.link.uri.replace('reservations', 'designs');
  const { prefixLanguage: language } = useSelector(({ appState }) => appState);


  //static only
  const singleResLink = item.link.uri.replace('reservations', 'designs');
  const multiResLink = item.link.uri.replace('reservations', 'designs');

  // non-static versions
  // const singleResLink = item.link.uri.replace('reservations', 'dashboard');
  // const multiResLink = item.link.uri.replace('reservations', 'dashboard');

  return (
    <Fragment>
      {shouldDisplay ? (
        <li className={classNames(styles.item, styles.itemWithLink)}>
          {noReservations ? (
            <Link
              to={window.location.origin+  getLanguagePrefix(language) + noResLink.replace('internal:', '')}
              className={styles.link}
              onClick={onClick}
            >
              <span className={styles.label}>{item.title}</span>
            </Link>
          ) : singleReservation ? (
            <Link
              to={
                window.location.origin + getLanguagePrefix(language) + singleResLink.replace('internal:', '')
              }
              className={styles.link}
              onClick={onClick}
            >
              <span className={styles.label}>{item.title}</span>
            </Link>
          ) : multiReservation ? (
            <Link
              to={
                window.location.origin +
                getLanguagePrefix(language) +
                multiResLink.replace('internal:', '')
              }
              className={styles.link}
              onClick={onClick}
            >
              <span className={styles.label}>{item.title}</span>
            </Link>
          ) : (
            <Link
              to={window.location.origin + getLanguagePrefix(language) + restResLink.replace('internal:', '')}
              className={styles.link}
              onClick={onClick}
            >
              <span className={styles.label}>{item.title}</span>
            </Link>
          )}
        </li>
      ) : null}
    </Fragment>
  );
};

AuthLink.propTypes = {
  menu: PropTypes.string.isRequired,
  item: PropTypes.any.isRequired,
  styles: PropTypes.any.isRequired,
  isAuth: PropTypes.bool,
  onClick: PropTypes.func,
  user: PropTypes.shape({
    reservations: PropTypes.arrayOf(PropTypes.object),
  }),
};

AuthLink.defaultProps = {
  isAuth: false,
  onClick: () => {},
};
